import {ReactNode} from "react"
import {Button, Card} from "react-bootstrap"
import {Link, useNavigate} from "react-router-dom"

export type PageBreadcrumb = {
    label: string
    to?: string
}

export default function PageHeader({
    title,
    icon,
    description,
    breadcrumbs = [],
    backTo,
    backLabel = "Zurück",
    actions,
}: {
    title: ReactNode
    icon?: string
    description?: ReactNode
    breadcrumbs?: PageBreadcrumb[]
    backTo?: string
    backLabel?: string
    actions?: ReactNode
}) {
    const navigate = useNavigate()

    return <Card className="mb-3">
        {breadcrumbs.length > 0 && <Card.Header className="py-2">
            <nav aria-label="Breadcrumb">
                <ol className="breadcrumb mb-0">
                    {breadcrumbs.map((item, index) =>
                        <li key={`${item.label}-${index}`}
                            className={`breadcrumb-item ${
                                item.to ? "" : "active"}`}
                            aria-current={item.to ? undefined : "page"}>
                            {item.to
                                ? <Link to={item.to}>{item.label}</Link>
                                : item.label}
                        </li>)}
                </ol>
            </nav>
        </Card.Header>}
        <Card.Body className="d-flex flex-wrap align-items-center
            justify-content-between gap-3">
            <div className="d-flex align-items-start gap-3">
                {backTo && <Button variant="outline-secondary"
                    onClick={() => navigate(backTo)}>
                    <i className="bi bi-arrow-left me-2"/>
                    {backLabel}
                </Button>}
                <div>
                    <h2 className="mb-1">
                        {icon && <i className={`bi ${icon} me-2`}/>}
                        {title}
                    </h2>
                    {description &&
                        <div className="text-muted">{description}</div>}
                </div>
            </div>
            {actions && <div className="d-flex flex-wrap gap-2">{actions}</div>}
        </Card.Body>
    </Card>
}
